module.exports = __webpack_public_path__ + "img/64_17.80ae40c6.png";